import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-report-fee-cancel',
  templateUrl: './report-fee-cancel.component.html',
  styleUrls: ['./report-fee-cancel.component.scss']
})
export class ReportFeeCancelComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
